import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import LanguageIcon from '@mui/icons-material/Language';
import InsightsIcon from '@mui/icons-material/Insights';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

const ICON_MAP = {
  building: ApartmentOutlinedIcon,
  box: Inventory2OutlinedIcon,
  people: GroupsOutlinedIcon,
  diamond: DiamondOutlinedIcon,
  alert: ReportProblemOutlinedIcon,
  flag: FlagOutlinedIcon,
  person: PersonOutlineOutlinedIcon,
  document: DescriptionOutlinedIcon,
  chat: ChatBubbleOutlineOutlinedIcon,
  badge: BadgeOutlinedIcon,
  star: StarOutlineIcon,
  work: WorkOutlineIcon,
  language: LanguageIcon,
  insights: InsightsIcon,
  checklist: FactCheckOutlinedIcon,
};

export const PROFILE_SECTION_ICON_OPTIONS = [
  { key: 'building', label: 'Building' },
  { key: 'box', label: 'Box' },
  { key: 'people', label: 'Users' },
  { key: 'diamond', label: 'Diamond' },
  { key: 'alert', label: 'Alert' },
  { key: 'flag', label: 'Flag' },
  { key: 'person', label: 'Person' },
  { key: 'document', label: 'Document' },
  { key: 'chat', label: 'Chat' },
  { key: 'badge', label: 'ID' },
  { key: 'star', label: 'Star' },
  { key: 'work', label: 'Work' },
  { key: 'language', label: 'Web' },
  { key: 'insights', label: 'Insights' },
  { key: 'checklist', label: 'Checklist' },
];

export const PRIMARY_PROFILE_SECTION_ICON_KEYS = PROFILE_SECTION_ICON_OPTIONS.slice(0, 9).map(
  (item) => item.key,
);

export const getProfileSectionIcon = (iconKey) => ICON_MAP[iconKey] || HelpOutlineOutlinedIcon;
